/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import EndpointsConst from "../consts/EndpointsConst";
import { getAPIUrl } from "../utilities/APIHelper";

class EnrollService {
  /**
   * [POST]
   * Submits enrollment request
   * @param {Object} formValues
   *
   * @returns {Promise}
   */
  submitEnrollRequest(formValues) {
    const url = getAPIUrl() + EndpointsConst.API.ENROLL.SUBMIT_ENROLL_REQUEST;
    return axios.post(url, formValues);
  }
}

export default new EnrollService();
